'use strict';

var _ = require('lodash');
var PriceRecommendationServicesAnalysisGridDataRetrieverService = function PriceRecommendationServicesAnalysisGridDataRetrieverService(pricingAnalysisCommonsDataService, configurationService) {
  function retrieveData(service, snapshotDate) {
    return pricingAnalysisCommonsDataService.retrieveLengthOfStayData(service, true, snapshotDate);
  }
  function getBenchmarkCarrier(direction, serviceData) {
    var mapBenchmarkCarrier = {
      inbound: 'compCarrierInbound',
      outbound: 'compCarrierOutbound'
    };
    var fieldName = mapBenchmarkCarrier[_.lowerCase(direction)];
    return _.get(serviceData, fieldName, '');
  }
  function transform(data, originalService) {
    var prepareData = {
      'single': prepareSingleItineraryData,
      'roundTrip': prepareRoundTripData
    };
    var strategy = pricingAnalysisCommonsDataService.isSingleItinerary(originalService) ? 'single' : 'roundTrip';
    return prepareData[strategy](data, originalService);
  }
  function prepareSingleItineraryData(data, originalService) {
    var index = 1;
    return [transformService(_.find(data, {
      serviceId: originalService.serviceId
    }), index, originalService)];
  }
  function prepareRoundTripData(data, originalService) {
    var index = 1;
    var referenceServiceIds = originalService.referenceServiceIds;
    var serviceId = originalService.serviceId;
    var shoppingRecordsIds = originalService.shoppingRecordsIds;
    var result = [];
    _.forEach(referenceServiceIds, function (referenceServiceId) {
      var selectedService = _.find(data, {
        serviceId: serviceId,
        referenceServiceId: referenceServiceId
      });
      var referenceService = _.find(data, function (el) {
        return el.serviceId === referenceServiceId && el.referenceServiceId === serviceId && shoppingRecordsIds.indexOf(el.shoppingRecordId) !== -1;
      });
      if (!_.isUndefined(selectedService) && !_.isUndefined(referenceService)) {
        var services = [];
        if (selectedService) {
          services.push(transformService(selectedService, index, originalService));
        }
        if (referenceService) {
          services.push(transformService(referenceService, index, originalService));
        }
        result = result.concat(services);
        index++;
      }
    });
    return result;
  }
  function addPropertiesIfDefined(originalService, service, itinDetails) {
    var weight = originalService.riaMethod === 'Weighted Avg' ? service.weight : undefined;
    var ppsValue = getPPSValue(service);
    if (service.bvAdjustment) {
      itinDetails.bvAdjustment = service.bvAdjustment;
    }
    if (service.todBank) {
      itinDetails.todBank = service.todBank;
    }
    if (ppsValue) {
      itinDetails.ppsValue = ppsValue;
    }
    if (weight) {
      itinDetails.weight = weight;
    }
  }
  function transformService(service, itinNumber, originalService) {
    var itinDetails = {
      itinNumber: itinNumber,
      direction: _.capitalize(service.direction),
      service: service.displayServiceId,
      departureDate: service.departureDate,
      hostShare: formatPercentage(service.hostShare),
      compShare: formatPercentage(service.competitorShare),
      diffShare: formatPercentage(service.hostShare - service.competitorShare),
      currClass: getCurrentClass(service),
      hostRT: service.roundTripFareOriginal,
      hostRTNormalized: service.normalizedRoundTripFare || '-',
      effectiveBenchmarkFare: service.effectiveBenchmarkFare || '-',
      effectiveBenchmarkFareNormalized: service.normalizedEffectiveBenchmarkFare || '-',
      recommendedRT: service.fareRecommended || '-',
      hostOW: service.oneWayFareInitialOriginal,
      hostOWNormalized: service.oneWayFareOriginal || '-',
      recommendedOWChange: service.fareChange,
      strategy: service.recommendationStrategy,
      benchmarkCarrier: getGridBenchmarkCarrier(service),
      riaMethod: service.riaMethod,
      medianFareChange: service.medianFareChange,
      recomFareMethod: service.recomFareMethod,
      fareChangePPS: service.fareChangePPS,
      fareChangeML: service.fareChangeML,
      carryCount: service.carryCount,
      recommendedFare: service.recommendedFare,
      uncappedRecommendedFare: service.uncappedRecommendedFare
    };
    addPropertiesIfDefined(originalService, service, itinDetails);
    return itinDetails;
  }
  function getCurrentClass(service) {
    return _.isUndefined(service.fbShort) ? service.initialOriginalClass : [service.initialOriginalClass, ' ', service.fbShort].join('');
  }
  function getGridBenchmarkCarrier(service) {
    var benchmarkCarrier = getBenchmarkCarrier(service.direction, service);
    return _.isUndefined(service.fbShortComp) || _.isUndefined(service.appliedNormalization) ? benchmarkCarrier : [benchmarkCarrier, ' ', service.fbShortComp, ' (', service.appliedNormalization, ')'].join('');
  }
  function getPPSValue(service) {
    if (configurationService.isDirectionalPpsEnabled()) {
      return formatPpsValue(service.directionalPpsValue, service.directionalPpsType);
    }
    return formatPpsValue(service.roundTripPpsValue, service.roundTripPpsType);
  }
  function formatPpsValue(value, strategyType) {
    if (value !== null && value !== undefined) {
      return strategyType === 'P' ? value + '%' : value;
    }
  }
  function formatPercentage(number) {
    return _.isUndefined(number) || _.isNaN(number) ? '-' : _.round(number * 100, 2) + '%';
  }
  function getData(originalService, snapshotDate) {
    return retrieveData(originalService, snapshotDate).then(pricingAnalysisCommonsDataService.filterServicesThatMatchLatestClass).then(_.partialRight(transform, originalService));
  }
  return {
    getData: getData
  };
};
PriceRecommendationServicesAnalysisGridDataRetrieverService.$inject = ['PricingAnalysisCommonsDataService', 'ConfigurationService'];
module.exports = PriceRecommendationServicesAnalysisGridDataRetrieverService;